import axios from 'axios';
import CartHelper from '../CartHelper';

const _CartHelper = new CartHelper();
const ISLOCAL = /localhost/gm;
const PROXY = ISLOCAL.test(location.href) ? 'https://cors-anywhere.herokuapp.com/' : '';

export const INIT_CART = 'init_cart';
export const initCart = (initCardData) => async (dispatch) => {
	dispatch({
		type: INIT_CART,
		payload: initCardData,
	});
};

export const SET_CART = 'set_cart';
export const setCart = (cartData, isNewProd, productsAdded) => async (dispatch) => {
	let cart = cartData;
	if (!Array.isArray(cart)) {
		cart.isNewProd = isNewProd;
		const titles = productsAdded.map((p) => p.products.find((product) => product.sku === p.activeSku)?.productTitle || '');
		cart.newProdTile = titles.join(' \n');
	}

	dispatch({
		type: SET_CART,
		payload: cart,
	});
};

export const GET_CART_STATE = 'get_cart_state';
export const getCartState = (cartId, istApiUrl) => async (dispatch) => {
	let token = _CartHelper.getAuthToken();
	let apiURl = `${PROXY}${istApiUrl}/carts/${cartId}`;
	let cart = {};
	await axios({
		url: apiURl,
		method: 'get',
		headers: {
			Authorization: token ? token : 'anonymous',
		},
		withCredentials: true,
		responseType: 'json',
	})
		.then((response) => {
			cart = response.data[0];
		})
		.catch((error) => {
			console.error('getCartState error: ', error);
			_CartHelper.removeExistingCartCookie(error);
		});

	dispatch({
		type: GET_CART_STATE,
		payload: cart,
	});
};

export const GET_CARTID_FROM_USER = 'get_cartid_from_user';
export const getCartIdFromUser = (istApiUrl) => async (dispatch) => {
	let token = _CartHelper.getAuthToken();
	let apiURl = `${PROXY}${istApiUrl}/carts?latest=1`;
	let cart = {};

	await axios({
		url: apiURl,
		method: 'get',
		headers: {
			Authorization: token ? token : 'anonymous',
		},
		withCredentials: true,
		responseType: 'json',
	})
		.then((response) => {
			cart = response.data[0];
			_CartHelper.setCookieCart(cart._id);
		})
		.catch((error) => {
			console.error('getCartState error: ', error);
			_CartHelper.removeExistingCartCookie(error);
		});

	dispatch({
		type: GET_CARTID_FROM_USER,
		payload: cart,
	});
};

export const SET_ADDED_BUNDLE = 'set_added_bundle';
export const CREATE_CART = 'create_cart';
export const createCart = (istApiUrl, requestModel, bundle) => async (dispatch) => {
	let token = _CartHelper.getAuthToken();
	let apiURl = `${PROXY}${istApiUrl}/carts`;
	let cart = {};

	await axios({
		url: apiURl,
		method: 'POST',
		headers: {
			Authorization: token ? token : 'anonymous',
		},
		data: requestModel,
		withCredentials: true,
		responseType: 'json',
	})
		.then((response) => {
			cart = response.data;
			_CartHelper.setCookieCart(cart._id);
		})
		.catch((error) => {
			console.error('Error creating cart: ,', error);
		});

	dispatch({
		type: CREATE_CART,
		payload: cart,
	});
	dispatch({
		type: SET_ADDED_BUNDLE,
		payload: bundle,
	});
};

export const ADD_TO_EXISTING_CART = 'add_to_existing_cart';
export const addToExistingCart = (istApiUrl, requestModel, cartId, bundle) => async (dispatch) => {
	let token = _CartHelper.getAuthToken();
	let apiURl = `${PROXY}${istApiUrl}/carts/${cartId}`;
	let cart = {};

	await axios({
		url: apiURl,
		method: 'PUT',
		headers: {
			Authorization: token ? token : 'anonymous',
		},
		data: requestModel,
		withCredentials: true,
		responseType: 'json',
	})
		.then((response) => {
			cart = response.data.cart;
		})
		.catch((error) => {
			console.error('ERROR addToExistingCart,', error);
		});

	dispatch({
		type: ADD_TO_EXISTING_CART,
		payload: cart,
	});
	dispatch({
		type: SET_ADDED_BUNDLE,
		payload: bundle,
	});
};

export const FLYOUT_STATE_UPDATE = 'flyout_state_update';
export const REMOVE_RECENT_BUNDLE = 'remove_recebt_bundle';
export const closeCartConfirmation = () => async (dispatch) => {
	dispatch({
		type: REMOVE_RECENT_BUNDLE,
		payload: [],
	});

	dispatch({
		type: FLYOUT_STATE_UPDATE,
		payload: false,
	});
};

export const flyoutSteteUpdate = (isOn) => async (dispatch) => {
	dispatch({
		type: FLYOUT_STATE_UPDATE,
		payload: isOn,
	});
};

export const FLYOUT_FORM_UPDATE = 'FLYOUT_FORM_UPDATE';
export const flyoutFormsUpdate = (formUpdate) => async (dispatch) => {
	dispatch({
		type: FLYOUT_FORM_UPDATE,
		payload: formUpdate,
	});
};
